import * as React from "react";
import "ag-grid-community/dist/styles/ag-theme-balham.css";
import "ag-grid-community/dist/styles/ag-theme-balham-dark.css"
import AgSelectAllHeader from "../../common/AgSelectAllHeader";
import Utils from "../../../../Utils";
import Axios from "../../../../config/Axios";
import toastr from "toastr";
import CreateGroupModal from "./components/createGroupModal/CreateGroupModal";
import {
    assignRoleToGroup,
    assignUserToGroup,
    createGroup,
    deleteGroup,
    editGroupName,
    getAllRoles,
    removeRoleFromGroup,
    removeUserToGroup
} from "../../../../actions/boCoreActions";
import AgGridFooter from "../../common/AgGridFooter";
import {helpHeaderTemplate} from "../../common/AgHeaderHelpToolTip";
import history from '../../../../config/history';
import {Prompt} from "react-router";
import './groupsGrid.css'
import AgGridUtils from "../../../../AgGridUtils";
import AgGridHelpToolTip from "../../common/AgGridFilterHelpTooltip";
import AccessControlModal, {Access, GridType} from "../../../common/AccessControlModal/AccessControlModal";
import {AttributeTypeEnum} from "../../enums/AttributeTypeEnum";

const AgGridReact = require('ag-grid-react').AgGridReact;

interface Props {
    renderInModal?: boolean,
    funcId?: any;
    access?: Access;
}

interface State {
    groupsColumnDefs: any;
    groupsGridApi: any;
    groupsColumnApi: any;
    usersColumnDefs: any;
    usersGridApi: any;
    usersColumnApi: any;
    rowData: any;
    selectedGroup: any;
    selectedGroupForEdit: any;
    modalData: any;
    loading: boolean;
    showModal: boolean;
    leave: boolean;
    areThereChanges: boolean;
    selectedRows: number;
    showUsers: string;
    isFilterChanged: boolean;
    modalBtnText: string;
    modalGroupInfo: any;
    gridType: GridType;
    access: Access;
    showRoleInfoModal: boolean;
    serverSideError: boolean
}

enum Users {
    SHOW_ALL = 'Show All',
    SHOW_ASSIGNED = 'Show Assigned'
}

class GroupsGrid extends React.Component<Props, State> {
    assignedUsers: any = [];
    constructor(props: Props) {
        super(props);
        this.state = {
            groupsColumnDefs: [],
            rowData: [],
            groupsGridApi: null,
            groupsColumnApi: null,
            usersColumnDefs: [],
            usersGridApi: null,
            usersColumnApi: null,
            loading: false,
            showModal: false,
            leave: false,
            areThereChanges: false,
            selectedGroup: null,
            selectedGroupForEdit: null,
            selectedRows: 0,
            modalData: {
                usedNames: [],
                users: [],
                roles: []
            },
            showUsers: Users.SHOW_ALL,
            isFilterChanged: false,
            modalBtnText: 'Manage Groups Access Control',
            modalGroupInfo: null,
            gridType: null,
            access: null,
            showRoleInfoModal: false,
            serverSideError: false
        };
    }

    componentDidMount() {
        this.buildUsersGrid()
        this.buildGroupsGrid();
        document.addEventListener('keydown', this.keydownHandlerGroups);
    }

    componentWillUnmount(): void {
        document.removeEventListener('keydown', this.keydownHandlerGroups);
    }

    restoreEventListener = () => {
        document.addEventListener('keydown', this.keydownHandlerGroups);
    }

    keydownHandlerGroups = (e) => {
        if (e.shiftKey && e.keyCode === 40) {
            e.preventDefault();
            Utils.$('.ag-floating-filter-input')[0].focus();
        }
        if (e.ctrlKey && e.altKey && e.keyCode === 78) {
            Utils.$('#new-group-btn').click();
        }
        if (e.ctrlKey && e.altKey && e.keyCode === 69) {
            Utils.$('#edit-btn').click();
        }
        if (e.ctrlKey && e.altKey && e.keyCode === 68) {
            Utils.$('#delete-btn').click();
        }
        if (e.ctrlKey && e.altKey && e.keyCode === 85) {
            Utils.$('#update-btn').click();
        }
        if (e.keyCode === 9) {
            e.preventDefault();
            const element = document.activeElement;
            const id = element.id.split('-')[3];

            if (element.classList.contains("ag-floating-filter-input")) {
                if (Utils.$('.ag-floating-filter-input').length - 1 === Number.parseInt(id)) {
                    this.setGridFistCellOnFocus(e);
                } else {
                    const index = Number.parseInt(id) + 1;
                    Utils.$('.ag-floating-filter-input')[index].focus();
                }
            }
        }
    }

    setGridFistCellOnFocus = (event) => {
        if (event.keyCode === 9) {
            event.preventDefault();

            // scrolls to the first row
            this.state.groupsGridApi.ensureIndexVisible(0);

            // scrolls to the current column
            let currentCol = this.state.groupsColumnApi.getAllDisplayedColumns()[0];
            this.state.groupsGridApi.ensureColumnVisible(currentCol);

            // sets focus into the grid cell
            this.state.groupsGridApi.setFocusedCell(0, currentCol);
        }
    };

    buildGroupsGrid = () => {
        let columnDefs = [
            {
                id: "",
                headerName: "ID",
                field: "id",
                headerTooltip: "id",
                type: 'text',
                width: 120,
                checkboxSelection: true,
                suppressSizeToFit: true,
                hide: !this.props.renderInModal,
                lockVisible:  !this.props.renderInModal,
                dataType: AttributeTypeEnum.INT,
            },
            {
                field: 'groupName',
                headerName: "Group Name",
                tooltipField: 'Group Name',
                headerTooltip: "Group Name",
                type: 'text',
                headerComponent: AgSelectAllHeader,
                width: 110,
                minWidth: 110,
                cellRenderer: (params) => {
                    return params.value;
                }
            },
            {
                field: 'roles',
                headerName: "Assigned Roles",
                tooltipField: 'Assigned Roles',
                headerTooltip: "Assigned Roles",
                type: 'text',
                width: 110,
                minWidth: 110,
                cellRenderer: (params) => {
                    const groupsRoles = params.value.map(role => {
                        return role.roleName
                    })
                    return groupsRoles.sort().join(', ')
                },
            },
            {
                field: 'groupFunctionalities',
                headerName: "Group Functionalities",
                tooltipField: 'Group Functionalities',
                headerTooltip: "Group Functionalities",
                sortable: false,
                filter: false,
                floatingFilter: false,
                width: 140,
                minWidth: 140,
                type: 'text',
                hide: this.props.renderInModal,
                lockVisible:  this.props.renderInModal,
                cellRenderer: (params: any) => {
                    const eDiv = document.createElement('div');
                    eDiv.innerHTML = `<button title="Group - Allowed Functionalities" id="show-allowed-funcs" class="show-allowed-btn">F</button>
                                       <button title="Group - Denied Functionalities" id="show-denied-funcs" class="show-denied-btn" style="margin-left: 8px">F</button>`

                    const eButtonGroupAllowed = eDiv.querySelectorAll('#show-allowed-funcs')[0];
                    const eButtonGroupDenied= eDiv.querySelectorAll('#show-denied-funcs')[0];
                    eDiv.style.cssText = 'display: flex; white-space: initial; width: 100%; justify-content: center; padding: 3px 0 3px 0';

                    eButtonGroupAllowed.addEventListener('click', (event) => {
                        event.stopImmediatePropagation();
                        Utils.blurTheActiveElements();
                        this.setAccessControlModalProps(GridType.FUNCTIONALITIES, Access.ALLOWED, {id: params.data.id, name: params.data.groupName});
                    });

                    eButtonGroupDenied.addEventListener('click', (event) => {
                        event.stopImmediatePropagation();
                        Utils.blurTheActiveElements();
                        this.setAccessControlModalProps(GridType.FUNCTIONALITIES, Access.DENIED, {id: params.data.id, name: params.data.groupName});
                    });

                    return eDiv;
                }
            },
        ]

        this.setState({
            groupsColumnDefs: columnDefs
        }, () => this.addFilterIndex())
    }

    addFilterIndex = () => {
        Utils.$(".ag-floating-filter-input").each(function (index) {
            Utils.$(this).attr('id', 'groups-search-filter-' + index);
            Utils.$(this).attr('index', (index + 2));
        });
    };

    setAccessControlModalProps = (gridType: GridType, access: Access, user: any) => {
        this.setState({
            gridType,
            access,
            modalGroupInfo: {
                ...this.state.modalGroupInfo,
                id: user.id,
                name: user.name
            }
        }, () => this.showAccessControlModal())
    }

    buildUsersGrid = () => {
        const columnDefs = [
            {
                id: "",
                headerName: "ID",
                field: "id",
                headerTooltip: "id",
                type: 'text',
                width: 120,
                suppressSizeToFit: true,
                checkboxSelection: true,
                headerComponent: AgSelectAllHeader,
                dataType: AttributeTypeEnum.INT,
            },
            {
                field: 'firstName',
                headerName: "First Name",
                tooltipField: 'FirstName',
                headerTooltip: "FirstName",
                type: 'text',
                cellRenderer: (params) => {
                    return params.value;
                }
            },
            {
                field: 'lastName',
                headerName: "Last Name",
                tooltipField: 'LastName',
                headerTooltip: "LastName",
                type: 'text',
                cellRenderer: (params) => {
                    return params.value;
                }
            },
            // {
            //     field: 'username',
            //     headerName: "Username",
            //     tooltipField: 'username',
            //     headerTooltip: "username",
            // },
            {
                field: 'email',
                headerName: "Email",
                tooltipField: 'Email',
                headerTooltip: "Email",
                type: 'text',
                cellRenderer: (params) => {
                    return params.value;
                }
            },
            {
                field: 'enabled',
                headerName: "Enabled",
                tooltipField: 'Enabled',
                headerTooltip: "Enabled",
                type: 'text',
                hide: true,
                lockVisible: true
            },
            {
                field: 'roles',
                headerName: "Roles",
                tooltipField: 'Roles',
                headerTooltip: "Roles",
                type: 'text',
                cellRenderer: (params) => {
                    return params.value.join(', ')
                }
            },
            {
                field: 'groups',
                headerName: "Groups",
                tooltipField: 'Groups',
                headerTooltip: "Groups",
                type: 'text',
                cellRenderer: (params) => {
                    const groupsNames = params.value.map(group => {
                        return group.groupName
                    })
                    return groupsNames.sort().join(', ')
                },
                hide: true,
                lockVisible: true
            },
        ];


        this.setState({
            usersColumnDefs: columnDefs
        })
    }

    onCreateEditHandler = (type) => {
        Utils.blurTheActiveElements();
        if (type === 'new') {
            getAllRoles()
                .then((response) => {
                    const roles = response.data.data.map(role => {
                        return {
                            id: role.id,
                            value: role.id,
                            label: role.roleName,
                        }
                    })
                    this.setState({
                        modalData: {
                            ...this.state.modalData,
                            roles: roles
                        },
                        showModal: true,
                        selectedGroupForEdit: null
                    })
                })
        } else {
            const selectedGroups = this.state.groupsGridApi.getSelectedRows();
            if (selectedGroups.length > 0) {
                getAllRoles()
                    .then((response) => {
                        const roles = response.data.data.map(role => {
                            return {
                                id: role.id,
                                value: role.id,
                                label: role.roleName,
                            }
                        })
                        this.setState({
                            modalData: {
                                ...this.state.modalData,
                                roles: roles
                            },
                            selectedGroupForEdit: selectedGroups[0],
                            showModal: true
                        })
                    })

            } else {
                toastr.warning("Please select one group");
            }
        }
    }

    onGridReady = (params: any) => {
        if (!this.state.groupsGridApi && !this.state.groupsColumnApi) {
            this.setState({
                groupsGridApi: params.api,
                groupsColumnApi: params.columnApi
            }, () => {
                params.api.sizeColumnsToFit();
                $("#hide-nav-btn").on("click", function () {
                    setTimeout(() => {
                        params.api.sizeColumnsToFit();
                    }, 500);
                });
            })
        }
        params.api.setServerSideDatasource(this.ServerSideDatasource());
    }

    onGridReadyFirstRender = (params: any) => {
        this.setState({
            groupsGridApi: params.api,
            groupsColumnApi: params.columnApi
        }, () => {
            this.setFilterFromHistory();
            params.api.sizeColumnsToFit();
            $("#hide-nav-btn").on("click", function () {
                setTimeout(() => {
                    params.api.sizeColumnsToFit();
                }, 500);
            });
        })
    }

    setFilterFromHistory = () => {
        // @ts-ignore
        if (history.location.state && history.location.state.groupName) {
            this.state.groupsGridApi.setFilterModel({
                groupName: {
                    filterType: "text",
                    type: "contains",
                    //@ts-ignore
                    filter: `=="${history.location.state.groupName}"`
                }
            })
            history.replace({
                ...history.location,
                state: undefined
            })
        }
    }

    onSelectionChanged = () => {
        const selected = this.state.groupsGridApi.getSelectedRows();
        if (this.props.renderInModal) {
            this.setState({
                modalBtnText: selected.length > 0 ? 'Edit Group Access Control' : 'Manage Groups Access Control'
            })
        } else {
            if (selected && selected.length > 0 && !this.props.renderInModal) {
                this.state.usersGridApi.deselectAll();
                this.assignedUsers = [];
                this.setState({
                    selectedGroup: selected[0],
                    selectedGroupForEdit: selected[0]
                }, () => {
                    this.showAssignedUsers();
                    this.setState({
                        showUsers: Users.SHOW_ALL
                    })
                    this.state.usersGridApi.setServerSideDatasource(this.usersServerSideDatasource())
                })

            }
        }
    }

    onUsersGridReady = (params: any) => {
        // usersGridApi.setServerSideDatasource it is assigned in the onSelectionChanged method
        this.setState({
            usersGridApi: params.api,
            usersColumnApi: params.columnApi
        }, () => {
            params.api.sizeColumnsToFit();
            $("#hide-nav-btn").on("click", function () {
                setTimeout(() => {
                    params.api.sizeColumnsToFit();
                }, 500);
            });
        })
    }

    onFirstRenderUsersGrid = (params: any) => {
        // usersGridApi.setServerSideDatasource it is assigned in the onSelectionChanged method
        this.setState({
            usersGridApi: params.api,
            usersColumnApi: params.columnApi
        }, () => {
            params.api.sizeColumnsToFit();
            $("#hide-nav-btn").on("click", function () {
                setTimeout(() => {
                    params.api.sizeColumnsToFit();
                }, 500);
            });
        })
    }

    ServerSideDatasource() {
        return {
            getRows: (params: any) => {
                const limit = params.request.endRow - params.request.startRow;
                const page = (params.request.endRow / limit) - 1;
                const sortObj = AgGridUtils.generateSortData(params.request.sortModel);
                const sortKeys = Object.keys(sortObj);
                let sort = sortKeys.length > 0 ? `&sort=${sortKeys[0] + ';' + sortObj[sortKeys[0]]}` : '';
                let filter = AgGridUtils.generateFilterDataV2(params);
                let apiPath = `access-control/group/all?size=${limit}&page=${page}${sort}&${filter}`;

                if (this.props.renderInModal && this.props.funcId && this.props.funcId !== -1) {
                    apiPath = `access-control/group/${this.props.funcId}/all?allowed=${this.props.access === Access.ALLOWED}&size=${limit}&page=${page}${sort}&${filter}`
                }

                const groupNames = [];
                Axios.instanceV2.get(apiPath)
                    .then((response: any) => {
                        const gridData = response.data.data.map(item => {
                            groupNames.push(item.groupName);
                            return {
                                id: item.id,
                                groupName: item.groupName,
                                roles: item.roles.length > 0 ? item.roles : []
                            }
                        });

                        if (gridData.length === 0) {
                            this.state.groupsGridApi.showNoRowsOverlay()
                            if (this.state.usersGridApi) {
                                this.setState({
                                    selectedGroup: null,
                                    selectedGroupForEdit: null,
                                    modalData: {
                                        ...this.state.modalData,
                                            usedNames: [],
                                            users: [],
                                            roles: []
                                    }
                                })
                                this.state.usersGridApi.setFilterModel(null);
                                this.state.usersGridApi.deselectAll();
                            }
                        }
                        try {
                            const lastRow = gridData.length < limit ? params.request.startRow + gridData.length : -1;
                            params.successCallback(gridData, lastRow);

                            this.state.groupsGridApi.gridOptionsWrapper.gridOptions.selectAllHeader.update(response.data.totalElements,
                                (limit * (page + 1)) > response.data.totalElements ?
                                    response.data.totalElements : (limit * (page + 1)),
                                params.parentNode.gridApi.getSelectedRows().length);

                            if (this.state.groupsGridApi.gridOptionsWrapper.gridOptions.selectAllHeader.isSelected()) {
                                this.state.groupsGridApi.gridOptionsWrapper.gridOptions.selectAllHeader.selectAll();
                            }

                            this.state.groupsGridApi.sizeColumnsToFit();
                            this.forceUpdate();
                            if (gridData.length > 0 && !this.props.renderInModal) {
                                this.state.groupsGridApi.forEachNode(node => node.rowIndex ? 0 : node.setSelected(true))
                                setTimeout(() => {
                                    const selected = this.state.groupsGridApi.getSelectedRows();
                                    if (selected && selected.length > 0 && this.state.usersGridApi) {
                                        this.setState({
                                            selectedGroup: selected[0],
                                            selectedGroupForEdit: selected[0],
                                            modalData: {
                                                ...this.state.modalData,
                                                usedNames: groupNames
                                            }
                                        }, () => {
                                            // this.state.usersGridApi.setServerSideDatasource(this.usersServerSideDatasource())
                                            this.showAssignedUsers()
                                        });
                                    }
                                }, 100)
                            }
                        } catch (e) {
                            console.error(e);
                        }
                    })
                    .catch((e) => {
                        AgGridUtils.serverSideErrorHandler(e)
                        params.failCallback();
                    })
            }
        }
    }

    usersServerSideDatasource() {
        return {
            getRows: (params: any) => {
                const limit = params.request.endRow - params.request.startRow;
                const page = (params.request.endRow / limit) - 1;
                const sortObj = AgGridUtils.generateSortData(params.request.sortModel);
                const sortKeys = Object.keys(sortObj);
                let sort = sortKeys.length > 0 ? `&sort=${sortKeys[0] + ';' + sortObj[sortKeys[0]]}` : '';
                let filter = AgGridUtils.generateFilterDataV2(params);

                if (this.state.selectedGroup === null) {
                    params.successCallback([], 0);
                    this.state.usersGridApi.showNoRowsOverlay()
                    this.state.usersGridApi.gridOptionsWrapper.gridOptions.selectAllHeader.update(0,
                        (limit * (page + 1)) > 0 ?
                            0: (limit * (page + 1)),
                        params.parentNode.gridApi.getSelectedRows().length);
                    return;
                }

                Axios.instanceV2.get(`user/all?size=${limit}&page=${page}${sort}&${filter}`)
                    .then((response: any) => {
                        const assignedUsers = [];
                        const gridData = response.data.data.map(item => {
                            if (item.groups.map(group => group.groupName).includes(this.state.selectedGroup.groupName)) {
                                item['removedByUser'] = false;
                                assignedUsers.push(item);
                            }
                            return {
                                id: item.id,
                                firstName: item.firstName,
                                lastName: item.lastName,
                                email: item.email,
                                enabled: item.enabled,
                                roles: item.roles,
                                groups: item.groups,
                                addedByUser: false,
                                removedByUser: false
                            }
                        });

                        if (gridData.length === 0) {
                            this.state.usersGridApi.showNoRowsOverlay()
                        }
                        try {
                            const lastRow = gridData.length < limit ? params.request.startRow + gridData.length : -1;
                            params.successCallback(gridData, lastRow);

                            this.state.usersGridApi.gridOptionsWrapper.gridOptions.selectAllHeader.update(response.data.totalElements,
                                (limit * (page + 1)) > response.data.totalElements ?
                                    response.data.totalElements : (limit * (page + 1)),
                                params.parentNode.gridApi.getSelectedRows().length);

                            if (this.state.usersGridApi.gridOptionsWrapper.gridOptions.selectAllHeader.isSelected()) {
                                this.state.usersGridApi.gridOptionsWrapper.gridOptions.selectAllHeader.selectAll();
                            }

                            this.state.usersGridApi.sizeColumnsToFit();
                            this.assignedUsers = assignedUsers;
                            this.forceUpdate();
                            this.setState({
                                isFilterChanged: false,
                                serverSideError: false,
                            })
                        } catch (e) {
                            console.error(e);
                        }

                    })
                    .catch((e) => {
                        this.setState({
                            serverSideError: true
                        })
                        AgGridUtils.serverSideErrorHandler(e);
                        params.failCallback();
                    })
            }
        }
    }

    createGroupHandler = (dto: any) => {
        createGroup(dto.groupName)
            .then((response: any) => {
                this.assignRolesToGroup(response.data.id, dto.selectedRoles);
            })
    }

    assignRolesToGroup = async (groupId: number, roles: any) => {
        const requests = [];
        roles.forEach(role => {
            requests.push(assignRoleToGroup(groupId, role.id))
        })

        try {
            const [response] = await Promise.all(requests);
            if (response) {
                this.state.groupsGridApi.onFilterChanged();
                this.hideModal();
            }
        } catch (e) {
            this.hideModal();
        }
    }

    editGroup = async (dto: any) => {
        const requests = [];
        let noChanges = true;
        if (dto.removedRoles.length > 0) {
            dto.removedRoles.forEach(roleId => {
                requests.push(removeRoleFromGroup(dto.groupId, roleId))
            })
            noChanges = false;
        }
        if (dto.groupName !== this.state.selectedGroup.groupName) {
            requests.push(editGroupName(dto.groupId, dto.groupName))
            noChanges = false;
        }
        if (dto.addedRoles.length > 0) {
            dto.addedRoles.forEach(roleId => {
                requests.push(assignRoleToGroup(dto.groupId, roleId))
            })
            noChanges = false;
        }


        if (noChanges) {
            toastr.warning('There are no changes')
        } else {
            try {
                const [response] = await Promise.all(requests);
                if (response) {
                    this.state.groupsGridApi.onFilterChanged();
                    this.hideModal();
                }
            } catch (e) {
                this.hideModal();
            }
        }
    }

    updateUsers = async () => {
        if (!this.state.serverSideError) {
            const requests = [];
            let noChanges = true;
            const selectedGroups = this.state.groupsGridApi.getSelectedRows()
            const editedRows = this.getEditedUserRows();

            if (editedRows.added.length > 0) {
                editedRows.added.forEach(user => {
                    requests.push(assignUserToGroup(selectedGroups[0].id, user.id))
                    noChanges = false;
                })
            }

            if (editedRows.removed.length > 0) {
                editedRows.removed.forEach(user => {
                    requests.push(removeUserToGroup(selectedGroups[0].id, user.id))
                    noChanges = false;
                })
            }

            if (noChanges) {
                toastr.warning('There are no changes')
            } else {
                try {
                    const [response] = await Promise.all(requests);
                    if (response) {
                        this.state.usersGridApi.onFilterChanged();
                        this.setState({
                            areThereChanges: false
                        })
                    }
                } catch (e) {

                }
            }
        }
    }

    getEditedUserRows = () => {
        if (this.state.usersGridApi) {
            const selectedUsers = this.state.usersGridApi.getSelectedRows()
            const added = selectedUsers.filter(user => user.addedByUser === true);
            const removed = this.assignedUsers.filter(user => user.removedByUser === true);
            return {
                added: added,
                removed: removed
            }
        }
        return {
            added: [],
            removed: []
        }
    }

    confirmModal = (nextLocation: any) => {
        if (this.areThereChanges()) {
            Utils.$.confirm({
                title: 'Confirm?',
                keyboardEnabled: true,
                escapeKey: 'cancel',
                backgroundDismiss: false,
                content: 'There are unsaved changes. Are you sure you want to continue?',
                type: 'red',
                theme: 'dark',
                typeAnimated: false,
                buttons: {
                    ok: {
                        text: "Yes!",
                        btnClass: 'btn-danger',
                        keys: ['enter'],
                        action: () => {
                            this.setState({
                                leave: true
                            }, () => history.push(nextLocation))
                        }
                    },
                    cancel: () => {

                    }
                }
            });
            return false
        }
        return true
    }

    areThereChanges = (): boolean => {
        if (this.state.leave) {
            return false
        }
        if (this.state.isFilterChanged) {
            return false
        }
        const editedRows = this.getEditedUserRows();

        if (editedRows.added.length > 0) {
            return true
        }
        if (editedRows.removed.length > 0) {
            return true
        }
        return false

    }

    onDeleteHandler = () => {
        const selectedRows = this.state.groupsGridApi.getSelectedRows()
        if (selectedRows.length === 1) {
            Utils.blurTheActiveElements();
            Utils.$.confirm({
                title: 'Confirm?',
                escapeKey: 'cancel',
                backgroundDismiss: false,
                theme: 'dark',
                typeAnimated: false,
                content: `You are about to delete 1 group, this procedure is irreversible.`,
                type: 'red',
                buttons: {
                    ok: {
                        text: "Yes!",
                        btnClass: 'btn-danger',
                        keys: ['enter'],
                        action: () => {
                            deleteGroup(selectedRows[0].id)
                                .then(() => {
                                    this.state.groupsGridApi.deselectAll();
                                    this.state.groupsGridApi.onFilterChanged();
                                })
                        }
                    },
                    cancel: () => {

                    }
                }
            });
        } else {
            toastr.warning("Please select one group");
        }
    }

    hideModal = () => {
        this.setState({
            showModal: false,
        })
    }

    selectAssignedUser = (params: any) => {
        if (params) {
            this.assignedUsers.forEach(item => {
                const found = params.api.getRowNode(item.id)
                if (found) {
                    if (!found.data.removedByUser) {
                        found.setSelected(true)
                    }
                    // found.selectable = false;
                }
            })
        }
    }

    onSelectionUserChanged = () => {
        this.setState({
            areThereChanges: this.areThereChanges(),
            selectedRows: this.state.usersGridApi ? this.state.usersGridApi.getSelectedRows().length : 0
        })
    }

    showAssignedUsers = () => {
        if (this.state.selectedGroup) {
            let ageFilterComponent = this.state.usersGridApi.getFilterInstance('groups');
            ageFilterComponent.setModel({
                type: 'contains',
                filter: `=="${this.state.selectedGroup.groupName}"`,
                filterTo: null,
            });
        }
    }

    showHideUsers = () => {
        this.state.usersGridApi.deselectAll();
        if (this.state.showUsers === Users.SHOW_ALL) {
            const filterModel = this.state.usersGridApi.getFilterModel();
            const filterKeys = Object.keys(filterModel);
            if (filterKeys.includes('groups')) {
                delete filterModel.groups;
            }
            this.state.usersGridApi.setFilterModel(filterModel);
            this.setState({
                showUsers: Users.SHOW_ASSIGNED,
                isFilterChanged: true
            })
        } else {
            this.showAssignedUsers();
            this.state.usersGridApi.onFilterChanged();
            this.setState({
                showUsers: Users.SHOW_ALL,
                isFilterChanged: true
            })
        }
    }

    navigateToGroups = () => {
        if (this.state.groupsGridApi.getSelectedRows().length > 0) {
            history.push({
                pathname: `${process.env.ENV_PREFIX}/groups`,
                state: {
                    groupName: this.state.groupsGridApi.getSelectedRows()[0].groupName
                }
            });
        } else {
            history.push(`${process.env.ENV_PREFIX}/groups`)
        }
    }

    showAccessControlModal = () => {
        this.setState({
            showRoleInfoModal: true
        })
    }

    hideAccessControlModal = () => {
        this.setState({
            showRoleInfoModal: false,
            access: null,
            gridType: null,
            modalGroupInfo: null
        })
    }

    onUsersGridFilterChanged = () => {
        this.setState({
            isFilterChanged: true
        }, () => {
            AgGridUtils.deselectAllRows(this.state.usersGridApi)
        })
    }

    render() {
        return (
            <div style={{height: '100%'}} className={'access-control-grid'}>
                { this.props.renderInModal === true ? null :<header style={{height: 50, backgroundColor: "#2D3436", display: 'flex'}}
                        className="bo-core-header top-header">
                    <div style={{
                        float: "left",
                        paddingLeft: 4,
                        width: "100%",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center"
                    }}>
                        <span id="groupsSearchTitle" className="header-title">Groups</span>
                        <div className="control-buttons">
                            <button onClick={() => this.onCreateEditHandler('new')} style={{marginRight: 2, height: 36}}
                                    className="btn btn-new-design"
                                    id={'new-group-btn'} title={'CTRL + ALT + N'}>
                                <i className="fas fa-plus"/>&nbsp;
                                <strong style={{fontSize: '13px'}} className={'shortcut-btn-letters'}>N</strong>ew
                            </button>
                            <button onClick={() => this.onCreateEditHandler('edit')}
                                    style={{marginRight: 2, height: 36}}
                                    className="btn btn-new-design"
                                    id={'edit-btn'} title={'CTRL + ALT + E'}>
                                <i className="fas fa-edit"/>&nbsp;
                                <strong style={{fontSize: '13px'}} className={'shortcut-btn-letters'}>E</strong>dit
                            </button>
                            <button onClick={() => this.updateUsers()}
                                    style={{marginRight: 2, height: 36}}
                                    className= {`btn btn-new-design ${this.state.areThereChanges && !this.state.serverSideError ? 'changes-triggered' : ''}`}
                                    id={'update-btn'} title={'CTRL + ALT + U'}>
                                <i className="fas fa-save"/>&nbsp;
                                <strong style={{fontSize: '13px'}} className={`shortcut-btn-letters`}>U</strong>pdate
                            </button>
                            <button onClick={this.onDeleteHandler} style={{height: 36}}
                                    id={'delete-btn'}
                                    title={'CTRL + ALT + D'}
                                    className="btn btn-danger">
                                <i className="fas fa-trash-alt"/> <strong style={{fontSize: '13px'}}
                                                                          className={'shortcut-btn-letters'}>D</strong>elete
                            </button>
                        </div>
                    </div>
                </header> }

                <div id={this.props.renderInModal === true ? 'modal-groups-grids-container' : 'groups-grids-container'}>
                    <div className={this.props.renderInModal === true ? 'groups-grid-full-width' : 'groups-grid'}>
                        <header className={'instance-layout-grid-header'} style={{height: 40}}>
                            <h5>Groups</h5>
                            {this.props.renderInModal ? <button onClick={this.navigateToGroups}
                                                                style={{height: 33, marginTop: 3, marginRight: 3}}
                                                                className="btn new-style-btn">{this.state.modalBtnText}</button> : null}
                        </header>
                        <div style={{width: "100%", height: "99%"}} id={'groups-grid'}
                             className={"ag-theme-balham-dark ag-grids"}>
                            <AgGridReact
                                onGridReady={this.onGridReady}
                                onFirstDataRendered={this.onGridReadyFirstRender}
                                columnDefs={this.state.groupsColumnDefs}
                                onSelectionChanged={this.onSelectionChanged}
                                onFilterChanged={() => AgGridUtils.deselectAllRows(this.state.groupsGridApi)}
                                defaultColDef={{
                                    minWidth: 150,
                                    flex: 1,
                                    filter: "agTextColumnFilter",
                                    floatingFilter: true,
                                    sortable: true,
                                    autoHeight: true,
                                    resizable: true,
                                    tooltipComponent: AgGridHelpToolTip,
                                    headerComponentParams: {
                                        template: helpHeaderTemplate
                                    },
                                    filterParams: {
                                        filterOptions: ['contains'],
                                        applyButton: true,
                                        clearButton: true,
                                        suppressAndOrCondition: true
                                    },
                                    floatingFilterComponentParams: {suppressFilterButton: true},
                                }}
                                gridOptions={{
                                    rowSelection: 'single',
                                    rowModelType: 'serverSide',
                                    getRowNodeId: function (data) {
                                        return data.id;
                                    },
                                    floatingFilter: true,
                                    suppressDragLeaveHidesColumns: true,
                                    suppressCellSelection: true,
                                    blockLoadDebounceMillis: 300
                                }}
                            >
                            </AgGridReact>
                            <AgGridFooter
                                totalCount={this.state.groupsGridApi ? this.state.groupsGridApi.gridOptionsWrapper.gridOptions.selectAllHeader.getState().totalItemsCount : 0}
                                loadedCount={this.state.groupsGridApi ? this.state.groupsGridApi.gridOptionsWrapper.gridOptions.selectAllHeader.getState().loadedItemsCount : 0}
                            />
                        </div>
                    </div>

                    {this.props.renderInModal === true ? null :
                        <React.Fragment>
                            <div id={'spacer-div'}/>
                            <div style={{width: "70%", height: "100%"}}>
                                <header className={'instance-layout-grid-header'} style={{height: 40}}>
                                    <h5>Group Assigned Users</h5>
                                    <button onClick={this.showHideUsers}
                                            style={{height: 33, marginTop: 3, marginRight: 3}}
                                            className="btn new-style-btn">{this.state.showUsers}</button>
                                </header>
                                <div style={{width: "100%", height: "99%"}} id={'group-users-grid'}
                                     className={"ag-theme-balham-dark ag-grids"}>
                                    <AgGridReact
                                        onGridReady={this.onUsersGridReady}
                                        onFirstDataRendered={this.onFirstRenderUsersGrid}
                                        columnDefs={this.state.usersColumnDefs}
                                        onFilterChanged={this.onUsersGridFilterChanged}
                                        defaultColDef={{
                                            minWidth: 150,
                                            flex: 1,
                                            filter: "agTextColumnFilter",
                                            floatingFilter: true,
                                            sortable: true,
                                            resizable: true,
                                            tooltipComponent: AgGridHelpToolTip,
                                            headerComponentParams: {
                                                template: helpHeaderTemplate
                                            },
                                            filterParams: {
                                                filterOptions: ['contains'],
                                                applyButton: true,
                                                clearButton: true,
                                                suppressAndOrCondition: true
                                            },
                                            floatingFilterComponentParams: {suppressFilterButton: true},
                                        }}
                                        gridOptions={{
                                            getRowNodeId: function (data) {
                                                return data.id;
                                            },
                                            floatingFilter: true,
                                            suppressDragLeaveHidesColumns: true,
                                            suppressCellSelection: true,
                                            suppressRowClickSelection: true,
                                            rowSelection: 'multiple',
                                            rowModelType: 'serverSide',
                                            onSelectionChanged: this.onSelectionUserChanged,
                                            onPaginationChanged: params => this.selectAssignedUser(params),
                                            onFirstDataRendered: params => this.selectAssignedUser(params),
                                            rowClassRules: {
                                                'deleted-relationship-row-background': (params: any) => {
                                                    let rel;
                                                    if (this.assignedUsers.length > 0 && params.node.data) {
                                                        const copy = JSON.parse(JSON.stringify(this.assignedUsers))
                                                        rel = copy.find(item => item.id === params.node.data.id);
                                                        if (rel) {
                                                            return params.node.data.removedByUser === true;
                                                        }
                                                    }
                                                },
                                                'add-new-user-to-group': params => {
                                                    if (params.node.data) {
                                                        return params.node.data.addedByUser === true;
                                                    }
                                                }
                                            },
                                            onRowSelected: (params: any) => {
                                                if (this.state.selectedGroup) {
                                                    const user = this.assignedUsers.find(item => item.id === params.node.data.id);
                                                    if (user) {
                                                        user['removedByUser'] = !params.node.selected;
                                                    } else {
                                                        params.node.data.addedByUser = params.node.selected;
                                                    }
                                                    params.node.data.removedByUser = !params.node.selected;
                                                    params.api.redrawRows();
                                                }
                                            },
                                        }}
                                    >
                                    </AgGridReact>
                                    <AgGridFooter
                                        totalCount={this.state.usersGridApi ? this.state.usersGridApi.gridOptionsWrapper.gridOptions.selectAllHeader.getState().totalItemsCount : 0}
                                        loadedCount={this.state.usersGridApi ? this.state.usersGridApi.gridOptionsWrapper.gridOptions.selectAllHeader.getState().loadedItemsCount : 0}
                                        selectedCount={this.state.usersGridApi ? this.state.selectedRows : 0}
                                    />
                                </div>
                            </div>
                        </React.Fragment>}
                </div>
                <AccessControlModal modalTitle={`${this.state.modalGroupInfo?.name} - ${this.state.access} ${this.state.gridType}`}
                                    showModal={this.state.showRoleInfoModal}
                                    gridType={this.state.gridType}
                                    access={this.state.access}
                                    modalGroupInfo={this.state.modalGroupInfo}
                                    closeModal={this.hideAccessControlModal}
                />
                <CreateGroupModal createGroup={this.createGroupHandler}
                                  editGroup={this.editGroup}
                                  restoreEventListener={this.restoreEventListener}
                                  hideModal={this.hideModal}
                                  showModal={this.state.showModal}
                                  selectedGroup={this.state.selectedGroupForEdit}
                                  modalData={this.state.modalData}/>
                <Prompt message={this.confirmModal}/>
            </div>
        );
    }
}

export default GroupsGrid



// WEBPACK FOOTER //
// ./app/components/bo-core/grids/GroupsGrid/GroupsGrid.tsx